import React, { createContext, useState } from "react";
import { Organization } from "../types";

interface SchoolContextType {
  schoolOrg: Organization;
  updateBranding: (
    colors: { primary: string; secondary: string },
    logo: string,
    name?: string,
  ) => void;
}

export const SchoolContext = createContext<SchoolContextType | undefined>(
  undefined,
);

export const SchoolProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [schoolOrg, setSchoolOrg] = useState<Organization>({
    id: "org_123",
    name: "Lincoln High School",
    colors: { primary: "#2563eb", secondary: "#000000" },
    logo_url: "",
    subscription_tier: "Elite",
    athlete_count: 142,
    coach_count: 12,
  });

  const updateBranding = (
    colors: { primary: string; secondary: string },
    logo: string,
    name?: string,
  ) => {
    setSchoolOrg((prev) => ({
      ...prev,
      colors,
      logo_url: logo,
      name: name || prev.name,
    }));
  };

  return (
    <SchoolContext.Provider value={{ schoolOrg, updateBranding }}>
      {children}
    </SchoolContext.Provider>
  );
};
